export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const SHOP_ROUTE = '/shop'
export const BASKET_ROUTE = '/basket'
export const PRODUCT_ROUTE = '/product'
export const HOME_ROUTE = '/'
export const SHOES_ROUTE = '/shoes'
export const TOYS_ROUTE = '/toys'
export const CLOTHES_ROUTE = '/clothes'
export const STORE_INFO_ROUTE = '/store-info'
export const UNIVERSAL_REPORT_ROUTE = '/admin/reports/universal'
export const VERIFY_EMAIL_ROUTE = '/verify-email'